import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { SRLWrapper } from 'simple-react-lightbox';
import { BannerApartment, BreadcumbApartment, MenuApartment } from '../common';
import { getGalleryInfo, getVideoInfo } from '../detailApartment.api';
import { getQueryString } from '../../../utils/params';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { useParams } from 'react-router-dom';

const GalleryComponent = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // const { t } = useTranslation();
  const { language } = useParams();
  // const getHref = window.location.href;
  const [galleryInfo, setGalleryInfo] = useState([]);
  const [listImages, setListImages] = useState([]);
  const [videoInfo, setVideoInfo] = useState([]);
  const [videoUrl, setVideoUrl] = useState('');
  const { id } = useParams();

  useEffect(() => {
    showLoader();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    getGalleryInfo(getQueryString({ language, projectId: id })).then(res => {
      if (res) {
        setGalleryInfo(res);
        if (res.images) {
          setListImages(res.images);
        }
      }
    });
    getVideoInfo(getQueryString({ language, projectId: id })).then(res => {
      hideLoader();
      if (res) {
        setVideoInfo(res);
        const _url = res[0]?.url.replace('watch?v=', 'embed/');
        setVideoUrl(_url);
      }
    });
    //eslint-disable-next-line
  }, []);

  const options = {
    settings: {
      disableWheelControls: true,
    },

    buttons: {
      backgroundColor: 'rgba(30,30,36,0.8)',
      iconColor: 'rgba(255, 255, 255, 0.8)',
      iconPadding: '5px',
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: true,
      showPrevButton: true,
      showThumbnailsButton: false,
      size: '30px',
      with: '100%',
    },
  };

  const handleGallery = () => {
    return (
      <div className="apartment-gallery">
        {videoInfo.map((item, index) => {
          return (
            <div key={index}>
              <div className="detail-apartment-title">{item.title}</div>
              {videoUrl ? (
                <div className="d-flex justify-content-center mb-5">
                  <iframe
                    width="560"
                    height="315"
                    src={videoUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              ): ('')}
            </div>
          );
        })}
        {galleryInfo ? (
          <>
            <div className="detail-photo-title">{galleryInfo.title}</div>
            <SRLWrapper options={options}>
              <div className="row">
                {listImages &&
                  listImages.map((item, index) => {
                    return (
                      <div className="col-4 apartment-gallery__media pb-4" key={index}>
                        <img
                          className="apartment-gallery__image"
                          src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                          alt={galleryInfo.name}
                        />
                      </div>
                    );
                  })}
              </div>
            </SRLWrapper>
          </>
        ) : (
          ''
        )}
      </div>
    );
  };

  return (
    <>
      <BreadcumbApartment />
      <BannerApartment />
      <MenuApartment />
      <div id="detailApartmentGallery">
        <div className="container">
          {handleGallery()}
          {/* {galleryInfo && galleryInfo.length > 0 ? (
            <div className="d-flex justify-content-center apartment-gallery__btn">
              <Link className="btn-booknow-a" to={`/${language}/preparation-page`}>
                <input
                  className="btn-booknow"
                  type="button"
                  value={
                    getHref.includes('?long')
                      ? t('detailApartment.contact_us_title')
                      : t('detailApartment.book_now_title')
                  }
                />
              </Link>
            </div>
          ) : (
            <div style={{ marginTop: '143px' }} className="d-flex justify-content-center apartment-gallery__btn">
              <Link className="btn-booknow-a" to={`/${language}/preparation-page`}>
                <input
                  className="btn-booknow"
                  type="button"
                  value={
                    getHref.includes('?long')
                      ? t('detailApartment.contact_us_title')
                      : t('detailApartment.book_now_title')
                  }
                />
              </Link>
            </div>
          )} */}
        </div>
      </div>
      {loader}
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GalleryComponent);
